import React from 'react';
import PropTypes from 'prop-types';
import { ReactComponent as InfoImage } from './images/info.svg';
import styles from './InfoBlock.module.scss';

const InfoBlock = ({ title, children }) => (
  <div className={styles.block}>
    <div className={styles.title}>
      <h3>
        <InfoImage />
        {title}
      </h3>
    </div>
    <div className={styles.content}>{children}</div>
  </div>
);

InfoBlock.propTypes = {
  children: PropTypes.node,
  title: PropTypes.string,
};

export default InfoBlock;
